import {
    GET_OTS_DASHBOARD_REQUEST,
    GET_OTS_DASHBOARD_SUCCESS,
    GET_OTS_DASHBOARD_ERROR
} from "../actions/types"
export default function (state = [], action) {
    const { type, payload } = action;
    switch (type) {

        case GET_OTS_DASHBOARD_REQUEST:
            return {
                loading: true,
            };
        case GET_OTS_DASHBOARD_SUCCESS:
            return {
                ...state,
                loading: false,
                payload,
            };
        case GET_OTS_DASHBOARD_ERROR:
            return {
                ...state,
                loading: false
            };
        default:
            return state;
    }
}